import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = { role: { role: "", role_id: "" } } as IUser;

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setDashboardUserCount: (state, action) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setDashboardUserCount } = dashboardSlice.actions;
export default dashboardSlice.reducer;

export const getUser = (state: RootState) => state.user;
